var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5809 15.596L10.8758 8.92053L17.5809 2.3245C18.1397 1.76821 18.1397 0.97351 17.5809 0.417219C17.0222 -0.139073 16.2239 -0.139073 15.6652 0.417219L8.96009 7.09271L2.33481 0.417219C1.77605 -0.139073 0.977827 -0.139073 0.419069 0.417219C-0.13969 0.97351 -0.13969 1.76821 0.419069 2.3245L7.12417 9L0.419069 15.6755C-0.13969 16.2318 -0.13969 17.0265 0.419069 17.5828C0.977827 18.1391 1.77605 18.1391 2.33481 17.5828L9.03991 10.9073L15.745 17.5828C16.3038 18.1391 17.102 18.1391 17.6608 17.5828C18.0599 16.947 18.0599 16.0728 17.5809 15.596Z",
    fill: "#565656"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b11ac66eabab51fbafa29e3a502f0f78.svg";
export { ForwardRef as ReactComponent };